export const NOT_FOUND_LABEL_TEXT = "Значение не найдено. Попробуйте ещё раз";
